/*
selector= CSS selector to find elements which should have the events bound to
domEvent= on which DOM event should be the GA event sent
name=	  GA function first parameter
value=	  GA function second parameter
label=    GA function third parameter
oneTIme=  (optional) GA event should be send only once
*/
var gaEventCounter = 0
function registerGAEvent(selector, domEvent, name, value, label, oneTime){
	if(!isGaSet) return
	oneTime = oneTime || false
	var $el = $(selector) 
	gaEventCounter++
	var gaEventId = gaEventCounter
	$el.bind(domEvent, function(e){
		var $t = $(this)
		if(!oneTime || (oneTime && !$t.hasClass('ga-event-' + gaEventId + '-sent'))){
			$t.addClass('ga-event-' + gaEventId + '-sent')
			ga('send', 'event', name, value, label);
		}
	})
}

/*
selector= CSS selector to find elements which should have the events bound to
domEvent= on which DOM event should be the FBQ event sent
name=	  FBQ function first parameter
*/
var fbqEventCounter = 0
function registerFBQEvent(selector, domEvent, name, oneTime){
	if(!isFbqSet) return
	oneTime = oneTime || false
	var $el = $(selector) 
	fbqEventCounter++
	var gaEventId = fbqEventCounter
	$el.bind(domEvent, function(e){
		var $t = $(this)
		if(!oneTime || (oneTime && !$t.hasClass('fbq-event-' + gaEventId + '-sent'))){
			$t.addClass('fbq-event-' + gaEventId + '-sent')
			fbq('track', name);
		}
	})
}